// API Configuration
// This file centralizes all API endpoints and base URLs

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

export const API_ENDPOINTS = {
  // CV Analysis
  UPLOAD_CV: `${API_BASE_URL}/upload-cv-1`,
  GET_CV_ANALYSIS_HISTORY: `${API_BASE_URL}/api/getCvAnalysisHistory`,
  
  // S3 Operations
  S3_UPLOAD: `${API_BASE_URL}/api/s3/upload`,
  S3_DOWNLOAD: `${API_BASE_URL}/api/s3/download`,
  S3_DELETE: `${API_BASE_URL}/api/s3/delete`,
  S3_URL: `${API_BASE_URL}/api/s3/url`,
  S3_LIST: `${API_BASE_URL}/api/s3/list`,
  
  // User CVs
  USER_CVS: `${API_BASE_URL}/api/user/cvs`,
  USER_CVS_DOWNLOAD: `${API_BASE_URL}/api/user/cvs/download`,
  USER_CVS_DELETE: `${API_BASE_URL}/api/user/cvs`,
  
  // Subscription
  SUBSCRIPTION: `${API_BASE_URL}/api/subscription`,
  
  // Data Download
  DATA_DOWNLOAD: `${API_BASE_URL}/api/data-download`,
  
  // Cover Letter
  COVER_LETTER: `${API_BASE_URL}/api/cover-letter`,
} as const;

export default API_BASE_URL;
